import styles from "./ProjectPreview.module.css";

const PREVIEW_IMAGES_ASPECT_RATIO = 2.7;

export default function ProjectPreview(props){ // props: name, images, description
  const images = props.images;
  var totalAspectRatio = 0;
  for (var i = 0; i < images.length; i++) {
    var aspectRatio = images[i].width / images[i].height;
    totalAspectRatio += aspectRatio;
  }
  var imagesObject;
  var extraPaddingPerSide = (PREVIEW_IMAGES_ASPECT_RATIO - totalAspectRatio) / 2;
  
  imagesObject = [];

  if (extraPaddingPerSide > 0)
    imagesObject.push(<span key="-1" style={{flex: extraPaddingPerSide}}/>);

  props.images.forEach((img, index) => 
    imagesObject.push(
      <span key={index} style={{"flex": (img.width / img.height).toString()}}>
        <span>
          <img className={styles.project_image + " " + styles.limit_height} src={img.path} alt={img.altText}/>
        </span>
      </span>
    )
  )
    
  if (extraPaddingPerSide > 0)
    imagesObject.push(<span key={images.length} style={{flex: extraPaddingPerSide}}/>);

  


  return (
    <div className={styles.preview}>
      <span className={styles.project_name}>{props.name}</span>
      <div className={styles.project_images}>
        {imagesObject}
      </div>
      <hr className={styles.image_description_seperator}/>
      <span className={styles.project_description}>{props.description}</span>
    </div>
  )
}